import { createAction } from '@reduxjs/toolkit';
import moment from 'moment';
import {
  SpaceTabDocumentType,
  SpaceTab as SpaceTabApi,
  UpdateSpaceTabPayload as UpdateSpaceTabPayloadT,
} from 'api/space/space-tab';
import { TaskSourceType } from 'api/tasks';
import { Task } from 'data/tasks';
import { HistoryPayload } from '../core';

export interface CreateSpaceTabPayload {
  space: { spaceId: number };
  url?: string;
  spaceTabType?: SpaceTabDocumentType;
  spaceTabTitle?: string;
  spaceTabId: 'new' | string;
  handleSuccess?(redirectPath: string, selectedSpaceId: number): void;
}

export interface UpdateSpaceTabTitle {
  spaceId: number;
  spaceTabTitle?: string;
}

export const createSpaceTabSagaAction = createAction<CreateSpaceTabPayload>(
  'spaceTabs/createSpaceTabSagaAction',
);

export const createSpaceTabSuccessSagaAction = createAction<SpaceTabApi>(
  'spaceTabs/createSpaceTabSuccessSagaAction',
);

export const deleteSpaceTabSagaAction = createAction<HistoryPayload<number>>(
  'spaceTabs/deleteSpaceTabSagaAction',
);

export interface UpdateSpaceTabPayload {
  spaceTabId: number;
  data: UpdateSpaceTabPayloadT;
}

export const updateSpaceTabSagaAction = createAction<UpdateSpaceTabPayload>(
  'spaceTabs/updateSpaceTabSagaAction',
);

export const fetchSpaceTabSagaAction = createAction<number>(
  'spaceTabs/fetchSpaceTabSagaAction',
);

export const spaceTabSuccessSagaAction = createAction<SpaceTabApi>(
  'spaceTabs/spaceTabSuccessSagaAction',
);

export interface CreateTaskPayload {
  projectId: number;
  spaceTabId: number;
  task: Partial<Task>;
}

function withPayloadType() {
  return (params: CreateTaskPayload) => ({
    payload: {
      ...params,
      task: {
        ...params.task,
        taskId: moment().valueOf(),
        source: {
          sourceType: TaskSourceType.SpaceTab,
          sourceId: params.spaceTabId,
        },
      },
    },
  });
}
export const createTaskFromSpaceTabSagaAction = createAction(
  'spaceTabs/createTaskFromSpaceTabSagaAction',
  withPayloadType(),
);

export const deleteTaskFromSpaceTabSagaAction = createAction<{
  projectId: number;
  spaceTabId: number;
  taskId: number;
}>('spaceTabs/deleteTaskFromSpaceTabSagaAction');
